import moment from 'moment';
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Button, Divider, Form, Grid, Header, Icon, List, Segment, Sticky, TextArea, TextAreaProps } from "semantic-ui-react";
import * as Chiamate from '..';
import { ApplicationState, strings } from '../..';
import { Matricola, TipoIntervento } from '../../core-assistenza';
import Notification from '../../notification';
import { ChiamataAttiva } from '../models';
import { getStatoValues } from '../utility';
import TipiRichiesta from './TipiRichiesta';
import { FileSelector, Allegato } from '../../archiviazione';

type OwnProps = {
    matricola: Matricola,
    tipologia: TipoIntervento,
    idTipoRichiesta?: string,
    descrizioneAggiuntiva?: string,
    hasArchiviazione: boolean,
    allegati: Allegato[],
    onGoBack: (step: number) => void,
    onDettagliInseriti: (idTipoRichiesta: string, descrizione: string) => void,
    onImageAdded: (image: Allegato) => void,
    onImageRemoved: (image: Allegato) => void,
}

const connector = connect(
    (state: ApplicationState) => ({
        tipiRichiesta: state.chiamate.tipiRichiestaRiepiloghi.riepiloghi.tipiRichiesta,
        chiamateAttive: state.chiamate.tipiRichiestaRiepiloghi.riepiloghi.chiamateAttive
    }),
    Chiamate.actions
)
type PropsFromRedux = ConnectedProps<typeof connector>

type SelezionaRichiestaProps =
    OwnProps &
    PropsFromRedux

type SelezionaRichiestaState = {
    idTipoRichiesta: string,
    descrizioneAggiuntiva: string
}

class SelezionaRichiesta extends React.Component<SelezionaRichiestaProps, SelezionaRichiestaState> {
    
    private refTipiRichiesta = React.createRef<HTMLDivElement>();

    constructor(props: SelezionaRichiestaProps) {
        super(props);

        this.state = {
            idTipoRichiesta: props.idTipoRichiesta || '',
            descrizioneAggiuntiva: props.descrizioneAggiuntiva || ''
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        const { matricola, tipologia } = this.props;

        this.props.loadTipiRichiesta(matricola, tipologia);
    }

    render() {
        const { onGoBack, tipiRichiesta } = this.props;

        return (
            <Grid.Row>
                <Grid.Column width='4'>
                    <div ref={this.refTipiRichiesta}>
                        <TipiRichiesta
                            tipiRichiesta={tipiRichiesta}
                            currentIdTipoRichiesta={this.state.idTipoRichiesta}
                            onTipoRichiestaChanged={this.onTipoRichiestaChanged} />
                    </div>
                </Grid.Column>
                <Grid.Column width='7' textAlign='center'>
                    <Sticky context={this.refTipiRichiesta} offset={100}>
                        <Header as='h3' attached='top' icon='info circle' content={strings.chiamate.tipoRichiesta.dettagli} />
                        <Segment attached='bottom'>
                            <Form>
                                <TextArea
                                    placeholder={strings.chiamate.tipoRichiesta.dettagliPlaceholder}
                                    value={this.state.descrizioneAggiuntiva}
                                    rows={6}
                                    onChange={this.onDescrizioneAggiuntiviChanged} />
                            </Form>
                        </Segment>
                        <Divider hidden />
                        {this.props.hasArchiviazione && this.renderAggiungiAllegati()}
                        <Button primary content={strings.core.azioni.indietro} onClick={() => onGoBack(0)} style={{ marginRight: 15 }} />
                        <Button primary content={strings.core.azioni.conferma} onClick={this.onConfermaClick} />
                    </Sticky>
                </Grid.Column>
                <Grid.Column width='4'>
                    <Sticky context={this.refTipiRichiesta} offset={100}>
                        <Header as='h3' attached='top' icon='bell' content={strings.chiamate.tipoRichiesta.inCorso} />
                        <Segment attached>
                            {this.renderChiamateAttive()}
                        </Segment>
                    </Sticky>
                </Grid.Column>
            </Grid.Row>
        );
    }

    renderChiamateAttive = () => {
        const { chiamateAttive } = this.props;

        if (chiamateAttive.length === 0) {
            return (
                <Header as='h2' textAlign='center'>
                    <Header.Content>
                        {strings.chiamate.tipoRichiesta.noChiamateTitolo}
                        <Header.Subheader>{strings.chiamate.tipoRichiesta.noChiamateDescrizione}</Header.Subheader>
                    </Header.Content>
                </Header>
            );
        } else {
            return (
                <List divided relaxed>
                    {chiamateAttive.map(this.renderChiamataAttiva)}
                </List>
            );
        }
    }

    renderChiamataAttiva = (chiamata: ChiamataAttiva) => {
        const icon = getStatoValues(chiamata.stato);
        const descrizioneAggiuntivaFormattata = (
            chiamata.descrizioneAggiuntiva.split(/\r?\n/).map((s, index) => <span key={index}>{s} <br /></span>)
        );

        return (
            <List.Item key={chiamata.idChiamata}>
                <List.Icon name={icon.name} color={icon.color} size="large" verticalAlign="middle" />
                <List.Content>
                    <List.Header>{chiamata.tipoRichiesta}</List.Header>
                    <List.Description>{descrizioneAggiuntivaFormattata}</List.Description>
                    <div>
                        <br />
                        <Icon name='mail' />
                        Inviata da {chiamata.userName} {moment(chiamata.data).locale(strings.getLanguage()).fromNow()}
                    </div>
                </List.Content>
            </List.Item>
        );
    }

    /*renderAggiungiAllegati = () => (
        <> </>
    )*/

    renderAggiungiAllegati = () => (
        <>
            <FileSelector 
                images={this.props.allegati} 
                onImageAdded={this.props.onImageAdded}
                onImageRemoved={this.props.onImageRemoved}
            />
            <Divider hidden />
        </>
    )

    onConfermaClick = () => {
        if (this.state.idTipoRichiesta === '' || this.state.descrizioneAggiuntiva === '') {
            Notification.error(strings.chiamate.tipoRichiesta.errorMessage, strings.core.errori.datiNonValidi);
            return;
        }

        const { onDettagliInseriti } = this.props;
        if (onDettagliInseriti) {
            onDettagliInseriti(this.state.idTipoRichiesta, this.state.descrizioneAggiuntiva);
        }
    }

    onTipoRichiestaChanged = (idTipoRichiesta: string) => {
        this.setState({ idTipoRichiesta: idTipoRichiesta });
    }

    onDescrizioneAggiuntiviChanged = (_: React.FormEvent<HTMLTextAreaElement>, data: TextAreaProps) => {
        this.setState({ descrizioneAggiuntiva: String(data.value) || '' });
    }
}

export default connector(SelezionaRichiesta);